import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, Trophy, CalendarBlank, FilmSlate, ClipboardText, ChartBar } from "@phosphor-icons/react";
import { Header } from "./shared";

export default function Overview() {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/stats/overview").then((r) => setO(r.data)).catch(() => {}); }, []);
  const cards = [
    { label: "Teams", value: o?.teams, icon: Users },
    { label: "Players", value: o?.players, icon: Trophy },
    { label: "Games", value: o?.games, icon: CalendarBlank },
    { label: "Completed", value: o?.completed_games, icon: ChartBar },
    { label: "Highlights", value: o?.highlights, icon: FilmSlate },
    { label: "Pending Regs", value: o?.pending_registrations, icon: ClipboardText },
  ];
  return (
    <div data-testid="overview-tab">
      <Header title="Dashboard" />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="border border-white/10 bg-[#121212] p-6 hover:shadow-[0_0_12px_rgba(255,87,34,0.25)] transition-all duration-200">
            <c.icon size={24} className="text-[#FF5722] mb-3" />
            <div className="font-display text-5xl tabular-nums">{c.value ?? 0}</div>
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mt-1">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
